import { Dispatch, FC, SetStateAction } from "react";
import { Select, SelectProps } from "@mantine/core";

// ----------------------------------------------------------------------------

export type IDropDownProps = SelectProps & {
  activeValue?: string;
  setActiveValue?: Dispatch<SetStateAction<string>>;
};

const TDropDown: FC<IDropDownProps> = (props) => {
  const { activeValue, setActiveValue, className, classNames, ...other } =
    props;

  return (
    <Select
      value={activeValue}
      onChange={(value) =>
        value !== null && setActiveValue && setActiveValue(value)
      }
      placeholder="Select"
      checkIconPosition="right"
      className={className}
      classNames={{
        label: "mb-3",
        input: "h-full text-ellipsis md:w-[200px] md:text-base xl:w-[250px]",
        wrapper: "h-10 md:h-12",
        option: "py-2 md:text-base",
        ...classNames,
      }}
      {...other}
    />
  );
};

export default TDropDown;
